import React, { useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { confirmarPago } from "../services/api";

function PagoFallido() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const paymentId = searchParams.get("payment_id") || searchParams.get("collection_id");
    const ventaId   = localStorage.getItem("ventaId");
    if (ventaId) {
      confirmarPago(ventaId, "failure", paymentId).finally(() => {
        localStorage.removeItem("ventaId");
      });
    }
  }, [searchParams]);

  return (
    <div style={styles.container}>
      <div style={styles.icono}>❌</div>
      <h2>Pago no completado</h2>
      <p>Tu pago no fue procesado. Puedes intentarlo nuevamente.</p>
      <button style={styles.btn} onClick={() => navigate("/")}>Volver al inicio</button>
    </div>
  );
}

const styles = {
  container: { maxWidth: 480, margin: "80px auto", textAlign: "center", padding: "0 16px" },
  icono:     { fontSize: 64, marginBottom: 16 },
  btn: {
    marginTop: 24, padding: "12px 32px", backgroundColor: "#1a1a2e",
    color: "#fff", border: "none", borderRadius: 8, fontSize: 16, cursor: "pointer"
  }
};

export default PagoFallido;
